export default {
	sec_01: {
		title: {
			one: 'A ',
			two: 'convenient API',
			three: 'that quickly integrates various',
			four: 'payment methods.',
		},
		btn: {
			two: 'Learn more',
		},
	},
};
